import { render, staticRenderFns } from "./NotificationItemView.vue?vue&type=template&id=238ed1d4&scoped=true&"
import script from "./NotificationItemView.vue?vue&type=script&lang=ts&"
export * from "./NotificationItemView.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationItemView.vue?vue&type=style&index=0&id=238ed1d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238ed1d4",
  null
  
)

export default component.exports